/* eslint-disable no-restricted-syntax */
function setColors(json: any): void {
  for (const [key, value] of Object.entries<string>(json.customColorsNewFront)) {
    document.documentElement.style.setProperty(key, value);
  }
}
export default setColors;
